import { render, staticRenderFns } from "./procedure.vue?vue&type=template&id=7339bfd4&scoped=true"
import script from "./procedure.vue?vue&type=script&lang=js"
export * from "./procedure.vue?vue&type=script&lang=js"
import style0 from "./procedure.vue?vue&type=style&index=0&id=7339bfd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7339bfd4",
  null
  
)

export default component.exports